export const UIPrefix = 'mexui-';